import { createQueryHook } from '~/shared/providers/api/createQueryHook';

export const useCreateAddressPermissionQuery = createQueryHook(
  'transportation.createAddressPermission',
  () => ({
    checkUserPermission: {
      __args: {
        input: {
          action: 'accountAddressCreate',
        },
      },
      allowed: true,
      action: true,
      resource: true,
    },
  }),
  {
    select: (data) => data?.checkUserPermission,
  },
);
